/*
 * @Author: 谭聪 156638174@qq.com
 * @Date: 2023-08-19 12:29:40
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-11-09 20:52:40
 * @FilePath: /mall-fe/src/views/h5/Home/components/Banner.tsx
 * @Description: 渲染轮播广告栏
 *
 */

import ImageRenderer from './ImageRenderer';
import { Autoplay, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { useRouter } from 'next/router';
import { appLinkRecirect } from 'libs/helper';

/**
 * React组件，用于渲染轮播广告栏。
 *
 * @param {Object} props - 组件的属性对象。
 * @param {Array<BannerEntity>} props.banners - 要展示的轮播广告实体数组。
 * @returns {JSX.Element} 渲染的React元素，显示轮播广告栏。
 */
function Banner(props: { banners: Array<BannerEntity>; isQywx?: boolean }) {
  const router = useRouter();
  const goToLinkPage = (url) => {
    appLinkRecirect(url, router);
  };
  return (
    <div className="banner-main">
      <Swiper
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        modules={[Autoplay, Pagination]}
        pagination={{
          clickable: true,
        }}
        loop={true}
      >
        {props?.banners?.map((banner, index) => (
          <SwiperSlide key={index}>
            {/* 为兼容现有的广告位跳转至新的地址，加了goToLinkPage跳转逻辑 */}
            <span onClick={() => goToLinkPage(banner.link)}>
              <ImageRenderer path={banner.image} />
            </span>
          </SwiperSlide>
        ))}
      </Swiper>
      <style jsx>
        {`
          .banner-main {
            margin: 12px 16px;
          }

          .banner-main :global(.swiper) {
            height: 138px;
            border-radius: 10px;
          }
          .banner-main :global(.swiper-slide) {
            position: relative;
          }
          .banner-main :global(.swipe-content-title) {
            position: absolute;
            top: 30px;
            left: 14px;
            color: #fff;
            font-size: 16px;
            line-height: 22px;
          }

          .banner-main :global(.swiper-pagination) {
            text-align: left;
            left: 4px;
          }
          .banner-main :global(.swiper-pagination-bullet) {
            background-color: #fff;
            opacity: 0.5;
          }
          .banner-main :global(.swiper-pagination-bullet-active) {
            display: inline-block;
            width: 15px;
            border-radius: 5px;
            opacity: 1;
          }
        `}
      </style>
    </div>
  );
}

export default Banner;
